import React from 'react'
import { connect } from 'react-redux'
import UserForm from './UserForm'

import {
  clear_user,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearUser: () => dispatch( clear_user() ),
  }
}

class ConnectedUserNew extends React.Component {
  componentWillMount() {
    this.props.clearUser()
  }

  render(){
    return <UserForm actionName="create" headTitle="User"/>
  }
}

const UserNew = connect(mapStateToProps, mapDispatchToProps)(ConnectedUserNew)
export default UserNew



// WEBPACK FOOTER //
// ./src/js/components/UserNew.js